import { Button, styled } from '@mui/material';

export const StyledSubmitButton = styled(Button)(({ theme }) => ({
	padding: theme.spacing(1, 3),
	textTransform: 'capitalize',
	borderRadius: 4,
	height: 50,
}));
